import { eventBus } from '@/main.js'

export default {
  methods: {
    toggleFullScreen () {
      if (!this.fullScreenActive) {
        this.videoFullScreen()
      } else {
        this.cancelFullScreen()
      }
    },
    isFullScreen () {
      const query = matchMedia('all and (display-mode: fullscreen')
      if (query.matches === 'entered') return true
      else return false
    },
    videoFullScreen (event) {
      let elem = this.elementVideoBlock
      //  diferent methods for different browsers for requesting full screen
      if (!this.fullScreenActive) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
            .then(this.fullScreenSuccessRequest)
            .catch(this.fullScreenError)
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen()
            .then(this.fullScreenSuccessRequest)
            .catch(this.fullScreenError)
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen()
            .then(this.fullScreenSuccessRequest)
            .catch(this.fullScreenError)
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen()
            .then(this.fullScreenSuccessRequest)
            .catch(this.fullScreenError)
        }
      } else {
        this.cancelFullScreen()
      }
    },
    fullScreenError (err) {
      console.log(err)
    },
    fullScreenSuccessRequest () {
      eventBus.onVDogFloatingAction(true)
      if (this.isMobileDevice()) {
        // let iOS = !!navigator.platform && /iPhone|iPod/.test(navigator.platform)
        if (!(this.isIphone())) {
          //  for mobile devices, change video to lanscape, console log for desktop browsers on attempting rotation
          screen.orientation
            .lock('landscape')
            .then(function () {})
            .catch(function (error) {
              console.log(error)
            })
        } else {
          eventBus.setFullScreenVariable(true)
          this.fullScreenActive = true
          this.iphoneFullScreen()
        }
      }
      // so we know that we are in fullscreen mode
      eventBus.setFullScreenVariable(true)
      this.fullScreenActive = true
      eventBus.onVideoPositioning()
    },
    iphoneFullScreen () {
      eventBus.onComponentsVisibility(false)
      let elementBody = this.elementVGamesBody
      elementBody.classList.add('lock-scroll')

      // let videoElement = this.elementVideo

      if (typeof window.orientation === 'number') {
        // ... and if the absolute value of orientation is 90...
        if (Math.abs(window.orientation) === 90) {
          let elem = this.elementVideoBlock
          elem.style.height = '100vh'
          let scaleElement = this.elementScaleElement
          this.fullScreenRotation(scaleElement, 90)
        } else {
          // ... otherwise it's portrait
          let elem = this.elementVideoBlock
          elem.style.height = '100vh'
          return false
        }
      }
    },
    cancelFullScreen () {
      if (this.fullScreenActive) {
        // eslint-disable-next-line no-debugger
        try {
          if (document.exitFullscreen) {
            document.exitFullscreen()
              .then(this.fullScreenSuccessExitRequest)
              .catch(this.fullScreenSuccessExitRequest)
          } else if (document.mozCancelFullScreen) {
          /* Firefox */
            document.mozCancelFullScreen()
              .then(this.fullScreenSuccessExitRequest)
              .catch(this.fullScreenSuccessExitRequest)
          } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
            document.webkitExitFullscreen()
              .then(this.fullScreenSuccessExitRequest)
              .catch(this.fullScreenSuccessExitRequest)
          } else if (document.msExitFullscreen) {
          /* IE/Edge */
            document.msExitFullscreen()
              .then(this.fullScreenSuccessExitRequest)
              .catch(this.fullScreenSuccessExitRequest)
          }
        } catch (e) {
          this.fullScreenSuccessExitRequest()
        }
      }
    },
    fullScreenSuccessExitRequest () {
      eventBus.onComponentsVisibility(true)
      this.elementVGamesBody.classList.remove('lock-scroll')
      setTimeout(function () {
        eventBus.onVDogFloatingAction(false)
      }, 1500)
      eventBus.setFullScreenVariable(false)
      this.fullScreenActive = false
      eventBus.onVideoPositioning()

      if (this.isMobileDevice()) {
        if (!(this.isIphone())) {
        //  for mobile devices, change video to lanscape, console log for desktop browsers on attempting rotation
          screen.orientation
            .lock('portrait')
            .then(function () {})
            .catch(function (error) {
              console.log(error)
            })
        } else {
          this.iphoneCancelFullScreen()
        }
        eventBus.checkModal()
      }
    },
    iphoneCancelFullScreen () {
      let elem = this.elementVideoBlock
      elem.style.height = ''
      let scaleElement = this.elementScaleElement
      this.fullScreenRotation(scaleElement, 0)
      let elementBody = this.elementVGamesBody

      elementBody.classList.remove('lock-scroll')
      eventBus.onComponentsVisibility(true)
    },

    fullScreenRotation (elem, degrees) {
      let tmpRotValue = 'rotate(' + degrees + 'deg)'
      if (degrees === 90) {
        elem.setAttribute(
          'style',
          '-webkit-transform:' +
            tmpRotValue +
            '; -moz-transform:' +
            tmpRotValue +
            '; -ms-transform:' +
            tmpRotValue +
            '; -o-transform:' +
            tmpRotValue +
            '; transform:' +
            tmpRotValue +
            '; padding-bottom:100%'
        )
      } else {
        elem.setAttribute(
          'style',
          '-webkit-transform:' +
            tmpRotValue +
            '; -moz-transform:' +
            tmpRotValue +
            '; -ms-transform:' +
            tmpRotValue +
            '; -o-transform:' +
            tmpRotValue +
            '; transform:' +
            tmpRotValue +
            '; padding-bottom:' +
            ';'
        )
      }
    },
    exitHandler () {
      console.log('exitHandler')
      setTimeout(() => {
        if (this.fullScreenActive) {
          if (this.fullScreenActive &&
            (document.webkitIsFullScreen === false || document.mozFullScreen === false || document.msFullscreenElement === false)) {
            this.cancelFullScreen()
          }
        }
      }, 300)
    }
  }
}
